import HiUser from "../components/HiUser.js";
import FourCards from "../components/FourCards.js";
import SevenCards from "./SevenCards.js";
const Section = () => {
    return (
        <>
        
        <div>
            <div className="slice py-5">
                <div className="container">
                    <HiUser/>
                    <FourCards/>
                    <SevenCards/>
                </div>
            </div>
        </div>
        </>
    )
}

export default Section;